import React from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import KeywordClustersPanel from "./KeywordClustersPanel";
import ContentRefreshPanel from "./ContentRefreshPanel";
import PerformancePanel from "./PerformancePanel";

// Sub-tabs are routed rather than local state so each screen is deep-linkable:
// a bookmark, a reload or a link from an alert email all land on the right one.
// AdminDashboard highlights the top-level SEO tab via pathname.startsWith('/seo'),
// so both sub-paths keep it active without any change there.
const SUB_TABS = [
  { id: "keywords",    label: "Keyword Clusters", path: "/seo/keywords"    },
  { id: "performance", label: "Performance",      path: "/seo/performance" },
  { id: "refresh",     label: "Content Refresh",  path: "/seo/refresh"     },
];

/** Pathname → active tab id, defaulting to keywords. */
function activeTabFor(pathname) {
  if (pathname.startsWith("/seo/refresh")) return "refresh";
  if (pathname.startsWith("/seo/performance")) return "performance";
  return "keywords";
}

const AdminSeo = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const activeSubTab = activeTabFor(location.pathname);

  return (
    <div>
      {/* ── Sub-tabs ──────────────────────────────────────────────────────── */}
      <div className="flex gap-2 mb-6">
        {SUB_TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => navigate(tab.path)}
            className={`px-4 py-1.5 text-sm font-medium rounded-full border transition-colors ${
              activeSubTab === tab.id
                ? "bg-gray-800 text-white border-gray-800"
                : "bg-white text-gray-600 border-gray-300 hover:bg-gray-50 hover:text-gray-800"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <Routes>
        {/* Existing /seo bookmarks keep working. */}
        <Route path="/" element={<Navigate to="/seo/keywords" replace />} />
        <Route path="/keywords"    element={<KeywordClustersPanel />} />
        <Route path="/performance" element={<PerformancePanel />} />
        <Route path="/refresh"     element={<ContentRefreshPanel />} />
        <Route path="*" element={<Navigate to="/seo/keywords" replace />} />
      </Routes>
    </div>
  );
};

export default AdminSeo;
